<div class="sidemenu d-flex flex-column justify-content-center align-items-start" [ngClass]="{'sidemenu-hidden': !isOverviewActive}">
    <div class="w-100 mb-auto">
        @for (sidebarButton of sideBarButtonsTop; track $index) {
            <button
                mat-button
                sidebar-button
                type="button"
                [disabled]="sidebarButton.disabled"
                [class.sidemenu-button--active]="isButtonActive(sidebarButton)"
                (click)="sidebarButton.callback()">
                <img class="sidemenu-icon pe-none user-select-none" [src]="sidebarButton.icon" alt="">
                <span class="text-spacing text-color-primary text-center pe-none user-select-none">{{sidebarButton.text}}</span>
            </button>
        }
    </div>
    <div class="w-100 pb-4">
        @for (sidebarButton of sideBarButtonsBottom; track $index) {
            <button
                mat-button
                sidebar-button
                type="button"
                [disabled]="sidebarButton.disabled"
                [class.sidemenu-button--active]="isButtonActive(sidebarButton)"
                (click)="sidebarButton.callback()">
                <img class="sidemenu-icon pe-none user-select-none" [src]="sidebarButton.icon" alt="">
                <span class="text-spacing text-color-primary text-center pe-none user-select-none">{{sidebarButton.text}}</span>
            </button>
        }
    </div>
    <div class="toggle-sidebar d-flex justify-content-center align-items-center" (click)="toggle()">
        <span class="material-symbols-outlined pe-none user-select-none">
            arrow_menu_close
        </span>
    </div>
</div>
